package de.oevbs.kunde.kundenportal2.components

import de.oevbs.kosmos.ui.forms.inputgroup.common.TextInputType
import de.oevbs.kosmos.ui.forms.inputgroup.inputText
import de.oevbs.kosmos.ui.forms.inputgroup.standard.InputTextScope
import de.oevbs.kosmos.ui.icons.Icon
import de.oevbs.kosmos.ui.icons.MaterialIconsOutlined
import dev.fritz2.core.RenderContext
import dev.fritz2.core.Tag
import dev.fritz2.core.storeOf
import kotlinx.coroutines.flow.map
import org.w3c.dom.HTMLDivElement

private enum class PasswordMode(
    val inputType: TextInputType,
    val icon: Icon
) {
    Visible(TextInputType.Text, MaterialIconsOutlined.visibility_off),
    Hidden(TextInputType.Password, MaterialIconsOutlined.visibility)
}

/**
 * Wrapper-Komponente für Inputs, die ein custom Passwortfeld mit browser-unabhängiger Möglichkeit zum Anzeigen des
 * Passwortes als Freitext ermöglicht.
 *
 * Diese Funktionalität wird von einigen Browsern implementiert und von anderen nicht, was zur Folge hat, dass sich die
 * Inputs mit `type="password"` von Browser zu Browser unterschiedlich verhalten.
 * Diese Komponente soll einen Workaround für ein einheitliches Verhalten bereitstellen.
 *
 * Die Komponente wird analog zu den anderen Input-Komponenten über die DSL konfiguriert.
 *
 * __Wichtig:__ Die Wrapper-Komponente konfiguriert automatisiert den Typen des Input-Feldes sowie ein Icon zum
 * Ein-/Ausblenden des Passworts. Diese sollten daher _nicht manuell_ gesetzt werden!
 */
fun RenderContext.inputPassword(initialize: InputTextScope.() -> Unit): Tag<HTMLDivElement> {
    val passwordModeStore = storeOf(PasswordMode.Hidden)
    val togglePasswordMode = passwordModeStore.handle<Unit> { current, _ ->
        when (current) {
            PasswordMode.Hidden -> PasswordMode.Visible
            PasswordMode.Visible -> PasswordMode.Hidden
        }
    }

    return inputText {
        type(passwordModeStore.data.map { it.inputType })
        iconClickable(passwordModeStore.data.map { it.icon }) {
            clicks handledBy togglePasswordMode
        }
        initialize()
    }
}